import { render, staticRenderFns } from "./CourseLessonsPage.vue?vue&type=template&id=52bebf9b&scoped=true"
import script from "./CourseLessonsPage.vue?vue&type=script&lang=js"
export * from "./CourseLessonsPage.vue?vue&type=script&lang=js"
import style0 from "./CourseLessonsPage.vue?vue&type=style&index=0&id=52bebf9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bebf9b",
  null
  
)

export default component.exports